'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-overview',
        name: 'ai-overview',
        meta: {
            title: 'AI overview',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-overview/index'),
    },
];
